import { Components, Theme } from "@mui/material/styles";

export const navbarCustomizations: Components<Theme> = {
  MuiAppBar: {
    styleOverrides: {
      root: {
        boxShadow: "none",
      },
    },
  },
  MuiToolbar: {
    defaultProps: {
      sx: {
        backgroundColor: "background.paper",
      },
    },
  },
  MuiTabs: {
    defaultProps: {
      slotProps: {
        startScrollButtonIcon: { color: "info" },
        endScrollButtonIcon: { color: "info" },
      },
    },
    // styleOverrides: {
    //   scrollButtons: {
    //     color: "text.primary",
    //   },
    // },
  },
};
